import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { useFetch, fileUrl, usePageTitle } from "@/lib/api";
import { IMG } from "@/lib/content";
import { PageHero, Loading, Reveal } from "@/components/site/Bits";

export default function Teams() {
  usePageTitle("Teams & Coaching Staff");
  const { data, loading } = useFetch("/content/teams");
  return (
    <div data-testid="teams-page">
      <PageHero testid="teams-hero" eyebrow="2027 Teams & Coaching Staff" image={IMG.huddle}
        title={<>Eight Divisions.<br /><span className="text-gold">One Coast.</span></>}
        sub="6U through 8th Grade. Meet the head coaches leading the 2027 Tri County Allstars." />
      <section className="bg-pitch py-16 sm:py-24">
        <div className="wrap">
          {loading ? <Loading /> : (
            <div className="grid gap-5 sm:grid-cols-2 lg:grid-cols-4">
              {(data || []).map((t, i) => (
                <Reveal key={t.id} delay={(i % 4) * 0.06}>
                  <Link to={`/teams/${t.slug}`} className="group relative block aspect-[3/4] overflow-hidden bg-navy border border-line hover:border-gold transition-colors" data-testid={`team-card-${t.slug}`}>
                    {t.team_photo ? <img src={fileUrl(t.team_photo)} alt={`${t.name} team`} className="absolute inset-0 h-full w-full object-cover opacity-60 transition-transform duration-700 group-hover:scale-105" /> : <div className="absolute inset-0 stripes" />}
                    <div className="absolute inset-0 bg-gradient-to-t from-pitch via-pitch/40 to-transparent" />
                    <p className="absolute right-3 top-3 font-display text-8xl font-black italic leading-none text-stroke">{t.name.replace("8th Grade", "8G")}</p>
                    <div className="absolute inset-x-0 bottom-0 p-6">
                      <p className="font-mono text-[10px] uppercase tracking-[0.25em] text-gold">Head Coach</p>
                      <p className="font-display text-2xl font-extrabold uppercase italic">{t.head_coach || "TBA"}</p>
                      <div className="mt-4 flex items-center justify-between border-t border-white/15 pt-4">
                        <p className="font-display text-4xl font-black italic">{t.name}</p>
                        <ArrowUpRight className="h-6 w-6 text-gold transition-transform group-hover:rotate-45" />
                      </div>
                    </div>
                  </Link>
                </Reveal>
              ))}
            </div>
          )}
          <div className="mt-14 card-navy overflow-x-auto" data-testid="head-coaches-table">
            <table className="w-full text-left">
              <thead><tr className="border-b border-line font-mono text-[10px] uppercase tracking-[0.25em] text-gold"><th className="p-4">Division</th><th className="p-4">2027 Head Coach</th></tr></thead>
              <tbody>
                {(data || []).map((t) => (
                  <tr key={t.id} className="border-b border-line/50 last:border-0">
                    <td className="p-4 font-display text-xl font-black italic">{t.name}</td>
                    <td className="p-4 font-display text-xl font-bold uppercase">{t.head_coach}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </section>
    </div>
  );
}
